<template>
  <ul
    :class="componentClass"
    :style="componentStyle"
  >
    <li
      v-if="isShowingSingleIconFeature"
      :class="featureClass"
    >
      <span><i :class="`fa-solid fa-xl fa-fw fa-${singleIconName}`" /></span>
      <span class="margin-left-lg">All 9 styles of the &ldquo;{{ singleIconName }}&ldquo; icon</span>
    </li>

    <li :class="featureClass">
      <font-awesome-icon
        :icon="$v6.solid.faIcons"
        size="xl"
        fixed-width
      />
      <span class="margin-left-lg">All {{ $counts.icons.all.formatted }} icons in Font Awesome</span>
    </li>

    <li :class="featureClass">
      <font-awesome-icon
        :icon="$v6.solid.faSwatchbook"
        size="xl"
        fixed-width
      />
      <span class="margin-left-lg">Classic + Sharp styles of every icon</span>
    </li>

    <li :class="featureClass">
      <font-awesome-icon
        :icon="$v6.solid.faArrowDownToLine"
        size="xl"
        fixed-width
      />
      <span class="margin-left-lg">Ability to download Pro icons</span>
    </li>

    <li :class="featureClass">
      <font-awesome-icon
        :icon="$v6.solid.faFileCertificate"
        size="xl"
        fixed-width
      />
      <span class="margin-left-lg">A Perpetual license to Font Awesome Pro</span>
    </li>

    <li :class="featureClass">
      <font-awesome-icon
        :icon="$v6.solid.faSignalBars"
        size="xl"
        fixed-width
      />
      <span class="margin-left-lg">More pageviews and custom icons</span>
    </li>

    <li :class="featureClass">
      <font-awesome-icon
        :icon="$v6.solid.faCloudArrowUp"
        size="xl"
        fixed-width
      />
      <span class="margin-left-lg">Additional Pro plugins and services</span>
    </li>

    <li :class="featureClass">
      <font-awesome-icon
        :icon="$v6.solid.faBox"
        size="xl"
        fixed-width
      />
      <span class="margin-left-lg">Installation via Package Managers</span>
    </li>

    <li :class="featureClass">
      <font-awesome-icon
        :icon="$v6.solid.faToolbox"
        size="xl"
        fixed-width
      />
      <span class="margin-left-lg">Services and tools to make easy work of using icons</span>
    </li>

    <li
      v-if="isShowingTokenFeature"
      :class="featureClass"
    >
      <font-awesome-icon
        :icon="$v6.solid.faCoinFront"
        size="xl"
        fixed-width
      />
      <span class="margin-left-lg">API and npm tokens to easily integrate Font Awesome</span>
    </li>

    <li :class="featureClass">
      <font-awesome-icon
        :icon="$v6.solid.faParachuteBox"
        size="xl"
        fixed-width
      />
      <span class="margin-left-lg">Fresh icons, features, and software updates</span>
    </li>

    <li
      v-if="isShowingSupportFeature"
      :class="featureClass"
    >
      <font-awesome-icon
        :icon="$v6.solid.faUserHeadset"
        size="xl"
        fixed-width
      />
      <span class="margin-left-lg">Plus support from real humans</span>
    </li>
  </ul>
</template>

<script>
  export default {
    name: 'ProFeatures',

    props: {
      customStyle: {
        type: Object,
        default: () => {}
      },
      hasGridLayout: {
        type: Boolean,
        default: false
      },
      isShowingSupportFeature: {
        type: Boolean,
        default: false
      },
      isShowingSingleIconFeature: {
        type: Boolean,
        default: false
      },
      isShowingTokenFeature: {
        type: Boolean,
        default: false
      },
      singleIconName: {
        type: String
      }
    },

    computed: {
      componentClass() {
        return ['margin-top-lg', { row: this.hasGridLayout }]
      },
      componentStyle() {
        return {
          ...{ '--list-style-type': 'none' },
          ...{ '--list-padding-left': '0' },
          ...this.customStyle
        }
      },
      featureClass() {
        return ['display-flex flex-row flex-items-start padding-vertical-sm', { 'column-12 laptop:column-6 laptop:padding-right-md': this.hasGridLayout }]
      }
    }
  }
</script>
